/// <reference types="react" />

import { ISelectedPathNode } from "DistributedTasksCommon/TFS.Tasks.Types";

import { ArtifactPathPickerUtils } from "PipelineWorkflow/Scripts/Shared/Utils/ArtifactPathPickerUtils";
import { ContributionIds } from "PipelineWorkflow/Scripts/Common/Constants";
import { FeatureFlagUtils } from "PipelineWorkflow/Scripts/Shared/Utils/FeatureFlagUtils";

import * as SDK_Shim from "VSS/SDK/Shim";
import * as Utils_String from "VSS/Utils/String";
import * as VSS from "VSS/VSS";

SDK_Shim.registerContent("create-release-variables-value-artifact-path-picker-menu", (context) => {
    SDK_Shim.VSS.register(ContributionIds.CreateReleaseArtifactPathVariablePickerMenuContributionId, { 
        execute: (menuItemContext) => {
            ArtifactPathPickerUtils.launchArtifactPathDialog(
                Utils_String.empty, 
                menuItemContext.artifactsVersionsData.map((artifact) => { return artifact.artifactSource; }), 
                (selectedPathNode: ISelectedPathNode) => { menuItemContext.updateVariableValue(selectedPathNode.path); }, 
                () => {}
            );
        }
    });
});